import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { IconX } from "@tabler/icons-react";
import { CButton } from "@app/components/Common";
import { Text, View } from "@/styles/reactnative";
import { ThemeContext } from "@/theme/ThemeProvider";
import { useIsMobile } from "@/utils/CalVW";

interface IProps {
  closeModal?: () => void;
}

const CrossModalHeader = ({ closeModal }: IProps) => {
  const { textw } = useContext(ThemeContext).theme.COLORS;
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  return (
    <View
      style={{
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        height: isMobile ? 34 : 38,
        width: "100%"
      }}
    >
      <div
        style={{
          fontWeight: 700,
          letterSpacing: '-0.48px',
          fontFamily: 'NanumSquareRound',
          fontSize: isMobile ? 14 : 16,
          color: '#fff',
          lineHeight: 1
        }}
      >
        {t("marginMode")}
      </div>

      <CButton
        icon={<IconX size={isMobile ? 16 : 18} color={textw} />}
        style={{
          color: textw,
          padding: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 18,
          height: 18
        }}
        onClick={() => {
          closeModal && closeModal();
        }}
      />
    </View>
  );
};

export default CrossModalHeader;
